import { render } from "./MoldEntry.vue?vue&type=template&id=159bfc52"
import script from "./MoldEntry.vue?vue&type=script&lang=js"
export * from "./MoldEntry.vue?vue&type=script&lang=js"

import "./MoldEntry.vue?vue&type=style&index=0&id=159bfc52&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__